var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhanaflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v14H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v14H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.667h20V0H0v4.667Z",
    fill: "#E71F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14h20V9.333H0V14Z",
    fill: "#118B56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.333h20V4.667H0v4.666Z",
    fill: "#FDD64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.998 8.128-1.4.993.532-1.611-1.396-.998L9.46 6.51 9.998 4.9l.537 1.61 1.728.002-1.396.998.53 1.611-1.399-.993Z",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhanaflag);
export default __webpack_public_path__ + "static/media/ghanaflag.b87650bfc82f6bebd1c82802bbf93ee3.svg";
export { ForwardRef as ReactComponent };